export const dateToTimestamp = (date: string) => Math.floor(new Date(date).getTime() / 1000);
